export default __webpack_public_path__ + "static/media/ic_loader.e528791e.gif";